import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.applicationService = 'http://localhost:6076/';
export default class ApplicationService {
  async initializeExport(payload) {
    return await axiosInstance
      .post(`${envUrls.applicationService}export/bulk-export`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }

  async getOpenAlexData(payload) {
    return await axiosInstance
      .post(`${envUrls.applicationService}data-sources/open-alex`, payload)
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }

  async getDataSourceTotals() {
    return await axiosInstance
      .get(`${envUrls.applicationService}data-sources/totals/bluescout`) // Pass in appName parameter for BlueScout to make sure not to return Crunchbase data
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }

  async getTutorialVideos() {
    return await axiosInstance
      .get(`${envUrls.applicationService}tutorial-videos`, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }

  async getExportStatus(taskId) {
    return await axiosInstance
      .get(`${envUrls.applicationService}export/status/${taskId}`)
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }

  async getExportsByScan(scanId) {
    return await axiosInstance
      .get(`${envUrls.applicationService}export/scan/${scanId}`)
      .then((response) => response.data)
      .catch((error) => {
        return { error: error };
      });
  }
}
